import { Invoice } from "@/models/invoice";
import { Axios } from "./auth-service";
import { CompanyService } from "@/services/company-service";
import { Subscription } from "@/models/subscription";
import { Company } from "@/models/company";
import { ServerConfig } from "@/config/config";
import { Plan } from "@/models/plan";

export interface IGetAllSubscriptionsItem {
	company:Company | null;
	id:string;
	nextPayDate:Date | null;
	amount:string;
	status:string;
	tier:number;
	incorrectMetaData:boolean;
}

export interface IGetAllSubscriptionsResponse {
	items:IGetAllSubscriptionsItem[];
	count:number;
}

export class SubscriptionSerivceClass{
	private getUrl(companyId:number):string{
		return `${CompanyService.url}/${companyId}/subscriptions`;
	}

	private readonly subscriptionRouterUrl:string = `${ServerConfig.host}/admin/subscriptions`

	async getInvoices(companyId:number):Promise<Invoice[]>{
		let result = await Axios.get(`${this.getUrl(companyId)}/invoices`);
		return result.data.map((i:any)=>new Invoice(i));
	}

	async getSubscriptions(companyId:number):Promise<Subscription[]> {
		let result = await Axios.get(`${this.getUrl(companyId)}`);
		return result.data.map((s:any)=>new Subscription(s));
	}

	async getSubscription(companyId:number, subscriptionId:string){
		let result = await Axios.get(`${this.getUrl(companyId)}/${subscriptionId}`);
		return new Subscription(result.data);
	}

	async getCurrentSubscription(companyId:number){
		let result = await Axios.get(`${this.getUrl(companyId)}/active`);
		return new Subscription(result.data);
	}

	async cancelSubscription(companyId:number, subscriptionId:string):Promise<void> {
		await Axios.delete(`${this.getUrl(companyId)}/cancel-subscription/${subscriptionId}`);
	}

	async editMetadata(companyId:number, subscriptionId:string, data:any):Promise<Subscription>{
		let result = await Axios.post(`${this.getUrl(companyId)}/edit-metadata/${subscriptionId}`, data);
		return new Subscription(result.data);
	}

	async editSubscriptionPrice(companyId:number, subscriptionId:string, price:number, plan:Plan):Promise<Subscription>{
		let result = await Axios.post(`${this.getUrl(companyId)}/edit-price/${subscriptionId}/${price}`, plan.getJson());
		return new Subscription(result.data);
	}

	async computePriceOfPlan(companyId:number, plan:Plan):Promise<number>{
		let result = await Axios.post(`${this.getUrl(companyId)}/compute-price`, plan.getJson());
		console.log(result.data);
		return result.data.recuringPrice.total;
	}

	async editSubscriptionNextPaymentDate(companyId:number, subscriptionId:string, date:Date, plan:Plan):Promise<Subscription>{
		let d = Math.floor(date.getTime() / 1000);
		let result = await Axios.post(`${this.getUrl(companyId)}/edit-next-payment-date/${subscriptionId}/${d}`, plan.getJson());
		return new Subscription(result.data);
	}

	async applySubscription(companyId:number, subscriptionId:string):Promise<Company>{
		let result = await Axios.post(`${this.getUrl(companyId)}/apply-subscription/${subscriptionId}`);
		return new Company(result.data);
	}

	async getAllSubscriptions(limit:number, offset:string):Promise<IGetAllSubscriptionsResponse>{
		let response = await Axios.get(this.subscriptionRouterUrl, {params: {
			limit,
			offset
		}});
		let result:IGetAllSubscriptionsResponse = {
			count: response.data.count,
			items: (response.data.data as any[]).map(item=>{
				return {
					company: new Company(item.company),
					id: item.id,
					nextPayDate: item.nextPayDate ? new Date(item.nextPayDate) : null,
					amount: item.amount,
					status: item.status,
					tier: item.tier,
					incorrectMetaData: item.incorrectMetaData
				};
			})
		};
		return result;
	}
};

export const SubscriptionSerivce = new SubscriptionSerivceClass();